// extracted by mini-css-extract-plugin
module.exports = {"containerLoader":"Loader_containerLoader__2Bo3x"};